<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>审批汇总</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" type="border-card">
      <!-- start -->
      <el-tab-pane label="审批汇总" name="first">
        <!-- start -->
        <el-form :inline="true" :model="keywords">
          <el-form-item label="">
            <el-select v-model="keywords.shenpitype" placeholder="请选择" class="select">
              <el-option label="请选择审批类型" value="0"></el-option>
              <el-option label="费用报销" value="1"></el-option>
              <el-option label="差旅费报销" value="1001"></el-option>
              <el-option label="采购付款" value="2"></el-option>
              <el-option label="研发材料报销" value="3"></el-option>
              <el-option label="申请用章" value="4"></el-option>
              <el-option label="申请请假" value="5"></el-option>
              <el-option label="申请出差" value="6"></el-option>
              <el-option label="申请办公用品" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.tongjitime" type="year" value-format="yyyy" placeholder="统计日期" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- end -->
<!--       <div class="box">
          <ul class="profit">
            <li class="firstLi">年度待审合计：</li>
            <li><span>{{Numdaishenpi}}</span></li>
          </ul>
          <ul class="profit">
            <li>年度已审合计：<br></li>
            <li><span>{{Numyishenpi}}</span></li>
          </ul>
        </div> -->

        <el-table v-loading="loading" :data="dataList" border stripe class="mt15" height="400">
          <el-table-column prop="Name" :label="label1" min-width="150px" fixed></el-table-column>
          <el-table-column prop="SNumdaishenpi1" :label="labeldaishen1" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi1" :label="labelyishen1" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi2" :label="labeldaishen2" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi2" :label="labelyishen2" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi3" :label="labeldaishen3" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi3" :label="labelyishen3" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi4" :label="labeldaishen4" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi4" :label="labelyishen4" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi5" :label="labeldaishen5" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi5" :label="labelyishen5" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi6" :label="labeldaishen6" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi6" :label="labelyishen6" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi7" :label="labeldaishen7" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi7" :label="labelyishen7" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi8" :label="labeldaishen8" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi8" :label="labelyishen8" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi9" :label="labeldaishen9" min-width="100px"></el-table-column>
          <el-table-column prop="SNumyishenpi9" :label="labelyishen9" min-width="100px"></el-table-column>
          <el-table-column prop="SNumdaishenpi10" :label="labeldaishen10" min-width="120px"></el-table-column>
          <el-table-column prop="SNumyishenpi10" :label="labelyishen10" min-width="120px"></el-table-column>
          <el-table-column prop="SNumdaishenpi11" :label="labeldaishen11" min-width="120px"></el-table-column>
          <el-table-column prop="SNumyishenpi11" :label="labelyishen11" min-width="120px"></el-table-column>
          <el-table-column prop="SNumdaishenpi12" :label="labeldaishen12" min-width="120px"></el-table-column>
          <el-table-column prop="SNumyishenpi12" :label="labelyishen12" min-width="120px"></el-table-column>
          <el-table-column prop="SNumdaishenpiAll" :label="labeldaishenAll" min-width="120px" fixed="right"></el-table-column>
          <el-table-column prop="SNumyishenpiAll" :label="labelyishenAll" min-width="120px" fixed="right"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- end -->
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyShenPiTongJi',
  data () {
    return {
      activeName: 'first',
      keywords: {
        shenpitype: '1',
        tongjitime: ''
      },
      label1:'经办人',
      labeldaishen1:'1月待审金额',
      labelyishen1:'1月已审金额',
      labeldaishen2:'2月待审金额',
      labelyishen2:'2月已审金额',
      labeldaishen3:'3月待审金额',
      labelyishen3:'3月已审金额',
      labeldaishen4:'4月待审金额',
      labelyishen4:'4月已审金额',
      labeldaishen5:'5月待审金额',
      labelyishen5:'5月已审金额',
      labeldaishen6:'6月待审金额',
      labelyishen6:'6月已审金额',
      labeldaishen7:'7月待审金额',
      labelyishen7:'7月已审金额',
      labeldaishen8:'8月待审金额',
      labelyishen8:'8月已审金额',
      labeldaishen9:'9月待审金额',
      labelyishen9:'9月已审金额',
      labeldaishen10:'10月待审金额',
      labelyishen10:'10月已审金额',
      labeldaishen11:'11月待审金额',
      labelyishen11:'11月已审金额',
      labeldaishen12:'12月待审金额',
      labelyishen12:'12月已审金额',
      labeldaishenAll:'全年待审金额',
      labelyishenAll:'全年已审金额',
      Numdaishenpi: '0',
      Numyishenpi: '0',
      loading: false,
      dataList: []
    }
  },
  mounted () {
    this.keywords.tongjitime = Vue.prototype.FunGetTimeStringY().toString()
    this.apiShenPiTongJi()
  },
  methods: {
    clicksearch () {
      if(this.keywords.shenpitype == '1'
      || this.keywords.shenpitype == '1001'
      || this.keywords.shenpitype == '2'
      || this.keywords.shenpitype == '3'){
        this.labeldaishen1 = '1月待审金额'
        this.labelyishen1 = '1月已审金额'
        this.labeldaishen2 = '2月待审金额'
        this.labelyishen2 = '2月已审金额'
        this.labeldaishen3 = '3月待审金额'
        this.labelyishen3 = '3月已审金额'
        this.labeldaishen4 = '4月待审金额'
        this.labelyishen4 = '4月已审金额'
        this.labeldaishen5 = '5月待审金额'
        this.labelyishen5 = '5月已审金额'
        this.labeldaishen6 = '6月待审金额'
        this.labelyishen6 = '6月已审金额'
        this.labeldaishen7 = '7月待审金额'
        this.labelyishen7 = '7月已审金额'
        this.labeldaishen8 = '8月待审金额'
        this.labelyishen8 = '8月已审金额'
        this.labeldaishen9 = '9月待审金额'
        this.labelyishen9 = '9月已审金额'
        this.labeldaishen10 = '10月待审金额'
        this.labelyishen10 = '10月已审金额'
        this.labeldaishen11 = '11月待审金额'
        this.labelyishen11 = '11月已审金额'
        this.labeldaishen12 = '12月待审金额'
        this.labelyishen12 = '12月已审金额'
        this.labeldaishenAll = '全年待审金额'
        this.labelyishenAll = '全年已审金额'
      } else {
        this.labeldaishen1 = '1月待审数量'
        this.labelyishen1 = '1月已审数量'
        this.labeldaishen2 = '2月待审数量'
        this.labelyishen2 = '2月已审数量'
        this.labeldaishen3 = '3月待审数量'
        this.labelyishen3 = '3月已审数量'
        this.labeldaishen4 = '4月待审数量'
        this.labelyishen4 = '4月已审数量'
        this.labeldaishen5 = '5月待审数量'
        this.labelyishen5 = '5月已审数量'
        this.labeldaishen6 = '6月待审数量'
        this.labelyishen6 = '6月已审数量'
        this.labeldaishen7 = '7月待审数量'
        this.labelyishen7 = '7月已审数量'
        this.labeldaishen8 = '8月待审数量'
        this.labelyishen8 = '8月已审数量'
        this.labeldaishen9 = '9月待审数量'
        this.labelyishen9 = '9月已审数量'
        this.labeldaishen10 = '10月待审数量'
        this.labelyishen10 = '10月已审数量'
        this.labeldaishen11 = '11月待审数量'
        this.labelyishen11 = '11月已审数量'
        this.labeldaishen12 = '12月待审数量'
        this.labelyishen12 = '12月已审数量'
        this.labeldaishenAll = '全年待审数量'
        this.labelyishenAll = '全年已审数量'
      }
      if(this.keywords.shenpitype == '1' || this.keywords.shenpitype == '1001'){
        this.label1 = '经办人'
      }
      if(this.keywords.shenpitype == '2'){
        this.label1 = '供应商'
      }
      if(this.keywords.shenpitype == '3'){
        this.label1 = '报销人'
      }
      if(this.keywords.shenpitype == '4'){
        this.label1 = '经办人'
      }
      if(this.keywords.shenpitype == '5'){
        this.label1 = '申请人'
      }
      if(this.keywords.shenpitype == '6'){
        this.label1 = '申请人'
      }
      if(this.keywords.shenpitype == '7'){
        this.label1 = '申请人'
      }
      this.apiShenPiTongJi()
    },
    apiShenPiTongJi: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        shenpitype: that.keywords.shenpitype,
        tongjitime: that.keywords.tongjitime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ShenPiTongJi, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.Numdaishenpi = response.data.Numdaishenpi
            that.Numyishenpi = response.data.Numyishenpi
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box{
    display: flex;
}
.profit{
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-right: 100px;

    & li:first-child{
        width: 168px;

        & em{
            font-style: normal;
            color: #999;
            font-size: 12px;
        }
    }
    & li:last-child{
        flex: 1;

        & span{
            display: inline-block;
            padding-right: 5px;
            color: #f56c6c;
            font-size: 16px;
        }
    }
    & li.firstLi{
        width: 128px;
    }
}
</style>
